module.exports = __webpack_public_path__ + "img/mail.925931d5.png";